import { render, staticRenderFns } from "./accountAppeal.vue?vue&type=template&id=c9685f4e&scoped=true"
import script from "./accountAppeal.vue?vue&type=script&lang=js"
export * from "./accountAppeal.vue?vue&type=script&lang=js"
import style0 from "./accountAppeal.vue?vue&type=style&index=0&id=c9685f4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9685f4e",
  null
  
)

export default component.exports